import { http, HttpResponse } from "msw";
import { scheduleCommandStatusStream } from "./commandStatus";
/** Generate a mock UUID. */ function mockUuid() {
    return crypto.randomUUID();
}
export const handlers = [
    // conns.rs routes
    // load-conn returns 2 global_ids (one per node)
    http.put("/api/admin/ipsec/load-conn", async ({ request })=>{
        const body = await request.json();
        console.log("load-conn body:", body);
        const globalIds = [
            mockUuid(),
            mockUuid()
        ];
        scheduleCommandStatusStream(globalIds.map((id)=>({
                globalId: id,
                commandType: "load-conn"
            })));
        return HttpResponse.json({
            success: true,
            global_ids: globalIds,
            message: null
        });
    }),
    // unload-conn returns 2 global_ids (one per node)
    http.delete("/api/admin/ipsec/unload-conn", async ({ request })=>{
        const body = await request.json();
        console.log("unload-conn body:", body);
        const globalIds = [
            mockUuid(),
            mockUuid()
        ];
        scheduleCommandStatusStream(globalIds.map((id)=>({
                globalId: id,
                commandType: "unload-conn"
            })));
        return HttpResponse.json({
            success: true,
            global_ids: globalIds,
            message: null
        });
    }),
    // init-conn returns 1 global_id
    http.post("/api/admin/ipsec/init-conn", async ({ request })=>{
        const body = await request.json();
        console.log("init-conn body:", body);
        const globalIds = [
            mockUuid()
        ];
        scheduleCommandStatusStream(globalIds.map((id)=>({
                globalId: id,
                commandType: "init-conn"
            })));
        return HttpResponse.json({
            success: true,
            global_ids: globalIds,
            message: null
        });
    }),
    // kill-conn returns 1 global_id
    http.post("/api/admin/ipsec/kill-conn", async ({ request })=>{
        const body = await request.json();
        console.log("kill-conn body:", body);
        const globalIds = [
            mockUuid()
        ];
        scheduleCommandStatusStream(globalIds.map((id)=>({
                globalId: id,
                commandType: "kill-conn"
            })));
        return HttpResponse.json({
            success: true,
            global_ids: globalIds,
            message: null
        });
    })
];
export default handlers;
